// extracted by mini-css-extract-plugin
export default {"cardsContainer":"ImproveCardCollection_cardsContainer__j1-n4","disabledCard":"ImproveCardCollection_disabledCard__6zueD","matchingCard":"ImproveCardCollection_matchingCard__cu5wa"};